import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useDispatch } from 'react-redux';

import { refreshTokens } from '../../store/actions/user/userActions';
import Paragraph from '../Paragraph/Paragraph';
import { getTokens } from '../../util/helpers/getTokensHelper';
import ButtonPrimary from '../Buttons/Button';
import Modal from '../Modal';
import themeColors from '../../assets/styles/themeColors';

const RefreshModal = ({ isOpen, close }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { JwtToken, JwtRefreshToken } = getTokens();

  const handleConfirm = () => {
    if (JwtToken || JwtRefreshToken) {
      close(false);
      dispatch(
        refreshTokens({
          data: {
            JwtToken,
            JwtRefreshToken,
          },
        }),
      );
    }
  };

  return (
    <Modal
      onClose={handleConfirm}
      variant="md"
      label={t('refresh.title')}
      isOpen={isOpen}
      size="sm"
    >
      <Paragraph color={themeColors.colorTextXLLight} mb={28}>
        {t('refresh.cta')}
      </Paragraph>
      <ButtonPrimary onClick={handleConfirm} title={t('common.confirm')} />
    </Modal>
  );
};

RefreshModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};

export default RefreshModal;
